import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { FloatingTooltip } from '../../Floating'
import { ButtonSelect, SelectDropdownListHeader } from '../../Select'

import {
  REQUEST_TRANSLATION_TOOLBAR_CLOSE_BTN_QA_NAME,
  REQUEST_TRANSLATION_TOOLBAR_FROM_QA_NAME,
  REQUEST_TRANSLATION_TOOLBAR_SUBMIT_BTN_QA_NAME,
  REQUEST_TRANSLATION_TOOLBAR_SWITCH_BTN_QA_NAME,
  REQUEST_TRANSLATION_TOOLBAR_TO_QA_NAME,
} from './RequestTranslationToolbar.constants'
import { useRequestTranslationToolbar } from './RequestTranslationToolbar.hooks'

import * as styles from './RequestTranslationToolbar.module.css'

import CloseIcon from '../../../icons/close.svg'
import SwitchIcon from '../../../icons/external-request.svg'

function RequestTranslationToolbar({
  requestText,
  ukLanguageCode,
  userLanguageCode,
  onClose,
  onTranslate,
}) {
  const { t } = useTranslation()

  const {
    fromLanguageOption,
    handleChangeFromLanguageOption,
    handleChangeToLanguageOption,
    handleClearFromLanguageOption,
    handleClearToLanguageOption,
    handleSwitchLanguages,
    handleTranslate,
    isActionDisabled,
    isTranslateControlsDisabled,
    isTranslating,
    languageOptions,
    toLanguageOption,
  } = useRequestTranslationToolbar({
    requestText,
    ukLanguageCode,
    userLanguageCode,
    onTranslate,
  })

  const showSelectLanguagesTooltip =
    !isTranslateControlsDisabled && (!fromLanguageOption || !toLanguageOption)

  return (
    <div className={styles.requestTranslationToolbar}>
      <div className={styles.selects}>
        <ButtonSelect
          className={styles.select}
          controlProps={{
            className: styles.selectButton,
            contentProps: {
              placeholderProps: {
                className: styles.selectPlaceholder,
                text: t('RequestTranslate.SourcePlaceholderKey'),
              },
              valueItemProps: {
                textClassName: styles.selectValueText,
              },
            },
            height: BUTTON_HEIGHT_32,
          }}
          disabled={isTranslateControlsDisabled}
          listProps={{
            Header: SelectDropdownListHeader,
            emptyProps: { text: t('Table.SelectNoDataTextKey') },
          }}
          options={languageOptions}
          qaName={REQUEST_TRANSLATION_TOOLBAR_FROM_QA_NAME}
          value={fromLanguageOption}
          onClear={handleClearFromLanguageOption}
          onSelectItem={handleChangeFromLanguageOption}
        />
        <Button.Flat
          isGrey
          beforeIconProps={{ Icon: SwitchIcon }}
          className={styles.switchButton}
          disabled={isActionDisabled}
          height={BUTTON_HEIGHT_32}
          qaName={REQUEST_TRANSLATION_TOOLBAR_SWITCH_BTN_QA_NAME}
          tooltip={t('RequestTranslate.SwitchTooltipKey')}
          onClick={handleSwitchLanguages}
        />
        <ButtonSelect
          className={styles.select}
          controlProps={{
            className: styles.selectButton,
            contentProps: {
              placeholderProps: {
                className: styles.selectPlaceholder,
                text: t('RequestTranslate.TargetPlaceholderKey'),
              },
              valueItemProps: {
                textClassName: styles.selectValueText,
              },
            },
            height: BUTTON_HEIGHT_32,
          }}
          disabled={isTranslateControlsDisabled}
          listProps={{
            Header: SelectDropdownListHeader,
            emptyProps: { text: t('Table.SelectNoDataTextKey') },
          }}
          options={languageOptions}
          qaName={REQUEST_TRANSLATION_TOOLBAR_TO_QA_NAME}
          value={toLanguageOption}
          onClear={handleClearToLanguageOption}
          onSelectItem={handleChangeToLanguageOption}
        />
      </div>
      <div className={styles.actions}>
        <FloatingTooltip
          content={t('RequestTranslate.SelectLanguagesTooltipKey')}
          disabled={!showSelectLanguagesTooltip}
        >
          <span className={styles.translateButtonTooltipWrapper}>
            <Button.Outlined
              isGrey
              className={styles.translateButton}
              disabled={isActionDisabled}
              height={BUTTON_HEIGHT_32}
              isLoading={isTranslating}
              qaName={REQUEST_TRANSLATION_TOOLBAR_SUBMIT_BTN_QA_NAME}
              text={t('RequestTranslate.TranslateButtonKey')}
              textClassName={styles.translateButtonText}
              onClick={handleTranslate}
            />
          </span>
        </FloatingTooltip>
        <Button.Outlined
          isGrey
          beforeIconProps={{ Icon: CloseIcon }}
          height={BUTTON_HEIGHT_32}
          qaName={REQUEST_TRANSLATION_TOOLBAR_CLOSE_BTN_QA_NAME}
          tooltip={t('RequestTranslate.CloseTooltipKey')}
          onClick={onClose}
        />
      </div>
    </div>
  )
}

export default RequestTranslationToolbar
